import React, { FC } from "react";
import { ICashFlowData } from "types";
import cns from "classnames";
import { formatDate, formatSum } from "utils/format";
import styles from "../MobilePayouts/MobilePayouts.module.scss";

interface MobileCashFlowsProps {
  data: ICashFlowData[];
  className?: string;
}

export const MobileCashFlows: FC<MobileCashFlowsProps> = ({
  data,
  className,
}) => {
  return (
    <div className={cns(className)}>
      {data.map((item, index) => (
        <>
          <div key={index} className={styles.item}>
            <div className={styles.row}>
              <span className={styles.rowTitle}>Дата операции:</span>
              <span className={styles.rowValue}>
                {formatDate(item.dateCashFlow)}
              </span>
            </div>

            <div className={styles.row}>
              <span className={styles.rowTitle}>Тип операции:</span>
              <span className={styles.rowValue}>{item.typeOperation}</span>
            </div>

            <div className={styles.row}>
              <span className={styles.rowTitle}>Сумма:</span>
              <span className={styles.rowValue}>{formatSum(item.sum)}</span>
            </div>

            <div className={styles.row}>
              <span className={styles.rowTitle}>НДФЛ:</span>
              <span className={styles.rowValue}>{formatSum(item.ndfl)}</span>
            </div>

            <div className={styles.row}>
              <span className={styles.rowTitle}>К оплате:</span>
              <span className={styles.rowValue}>{formatSum(item.toPay)}</span>
            </div>
            <div className={styles.row}>
              <span className={styles.rowTitle}>Фактическая дата оплаты:</span>
              <span className={styles.rowValue}>
                {formatDate(item.factPaymentDate)}
              </span>
            </div>
            <div className={styles.row}>
              <span className={styles.rowTitle}>Оплачено ФЛ:</span>
              <span className={styles.rowValue}>
                {formatSum(item.factPaid)}
              </span>
            </div>
            <div className={styles.row}>
              <span className={styles.rowTitle}>Оплачено НДФЛ:</span>
              <span className={styles.rowValue}>
                {formatSum(item.factPaidNdfl)}
              </span>
            </div>
            <div className={styles.row}>
              <span className={styles.rowTitle}>Всего оплачено:</span>
              <span className={styles.rowValue}>{formatSum(item.paid)}</span>
            </div>
          </div>
        </>
      ))}
    </div>
  );
};
